module.exports = __webpack_public_path__ + "static/media/zeeshan.b38b5b70.JPG";